const FLAG_KEY = 'beaded:landing'

export function isLandingEnabled(): boolean {
  try {
    return localStorage.getItem(FLAG_KEY) === 'true'
  } catch {
    return false
  }
}

/**
 * Toggle the landing page feature flag and reload.
 * Usage from browser console: `toggleLanding()`
 */
function toggleLanding(): void {
  const next = !isLandingEnabled()
  if (next) {
    localStorage.setItem(FLAG_KEY, 'true')
  } else {
    localStorage.removeItem(FLAG_KEY)
  }
  // eslint-disable-next-line no-console
  console.log(`Landing page ${next ? 'enabled' : 'disabled'}. Reloading...`)
  window.location.reload()
}

;(globalThis as Record<string, unknown>).toggleLanding = toggleLanding
